import { call, put, takeLatest } from "redux-saga/effects";
import {
    onValidateLoginTokenSubmit, onValidateLoginTokenSuccess, onValidateLoginTokenError, onEnrolledSubmit, onEnrolledSuccess, onEnrolledError
} from "../Store/Slices/validateLoginTokenSlice";
import { enrollmentApi } from "../Context/EnrolledApi";
import { validateLoginTokenApi } from "../Context/validateLoginTokenApi";


function* validateLoginToken({ payload }) {
    try {
        const loginTokenResponseData = yield call(validateLoginTokenApi, payload);
        if (loginTokenResponseData.responseCode === "200") {
            yield put(
                onValidateLoginTokenSuccess({
                    data: loginTokenResponseData.response,
                    status_code: loginTokenResponseData.responseCode,
                })
            );
        } else {
            yield put(
                onValidateLoginTokenError({
                    data: loginTokenResponseData.response,
                })
            );
        }
    } catch (error) {
        // const message = error.message || "Something went wrong";
        // yield put(onValidateLoginTokenError({ data: {}, message, }));
    }
}
function* Enrolled({ payload }) {

    try {
        const enrolledResponseData = yield call(enrollmentApi, payload);
        if (enrolledResponseData.responseCode === "200") {
            yield put(
                onEnrolledSuccess({
                    enrolledData: enrolledResponseData.response,
                    status_code: enrolledResponseData.responseCode,
                })
            );
        }
        else {
            yield put(
                onEnrolledError({
                    enrolledData: enrolledResponseData.response,
                })
            );
        }
    } catch (error) {
        const message = error.message || "Something went wrong";
        yield put(onEnrolledError({ enrolledData: {}, message, }));
    }
}
export default function* validateLoginTokenSaga() {
    yield takeLatest(onValidateLoginTokenSubmit.type, validateLoginToken);
    yield takeLatest(onEnrolledSubmit.type, Enrolled);
}
